export default {
    order: function (input) {
        var results = [],
            objectKey;

        for (objectKey in input) {
            results.push(input[objectKey]);
        }

        return results.sort((e1, e2) => e1.order() - e2.order());
    }
};



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Utils/orderElement.js
 **/